import useIsThankYouRoute from "../../../hooks/useIsThankYouRoute";

const useIsFooter = ()=>{
    return useIsThankYouRoute();
}

export default useIsFooter;